import { render } from "./forgotPassword.vue?vue&type=template&id=79defbb3&scoped=true"
import script from "./forgotPassword.vue?vue&type=script&lang=js"
export * from "./forgotPassword.vue?vue&type=script&lang=js"

import "./forgotPassword.vue?vue&type=style&index=0&id=79defbb3&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79defbb3"]])

export default __exports__